<template>
  <div class="section">
    <div class="container">
      <div class="content">
        <!-- account address -->
        <div class="columns">
          <!-- address -->
          <div class="column is-four-fifths">
            <div>
              <!--  normal account -->
              <div v-if="!isContract" class="menu-label is-size-6">
                <span class="fa fa-user-circle"></span>
                <span>{{ $t("account.anonymous") }}</span>
              </div>
              <div v-if="isContract" class="menu-label is-size-6">
                <span class="fa fa-file-text"></span>
                <span>{{ $t("account.contract") }}</span>
              </div>
              <code class="is-size-6 has-text-weight-bold">
                {{ $route.params.account }}
              </code>
            </div>
            <live-tag/>
            <div class="subtitle">
              <br>
              <br>
              <b class="has-text-success">
                <i class="fa fa-money">&nbsp;&nbsp;</i>
                {{ $utils.formatAmount(account.balance, true) }} <!-- {{ $COINNAME }} -->
              </b>
            </div>
          </div>
          <!-- qr code -->
          <div class="column has-text-centered">
            <qrcode :value="qrAddress"
                    :options="{ size: 160 }"></qrcode>
          </div>
        </div>
        <div v-if="isContract">
          <table class="table contract-overview">
            <tbody>
              <tr>
                <td>{{ $t('account.creator') }}</td>
                <td>
                  <a v-bind:href="'#/account/'+ this.creator">
                    <code class="has-text-info">{{ this.creator }}</code>
                  </a>
                </td>
              </tr>
              <tr>
                <td>{{ $t('account.from_transaction') }}</td>
                <td>
                  <a v-bind:href="'#/tx/'+ this.contractCreateAt">
                    <code class="has-text-info">{{ this.contractCreateAt }}</code>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- unpocketed transactions -->
        <br>
        <h4>Pending Transactions</h4>
        <p>
          <i18n path="account.pending_desc" tag="span">
            <b place="send">{{ $t("account.send") }}</b>
            <b place="receive">{{ $t("account.receive") }}</b>
          </i18n>
          <br>
          <span class="is-italic has-text-grey">{{ $t("account.pending_note") }}</span>
        </p>
        <p>

        </p>
        <div class="has-text-grey">
          <p>
            {{ $t("account.no_pending") }}
          </p>
        </div>
        <!-- completed transactions-->
        <br>
        <h4>{{ $t("account.completed", {count: completeTransactionCount}) }}</h4>
        <i18n path="account.update" tag="p">
          <b place="date">{{ lastUpdate }}</b>
        </i18n>
        <account-transaction-table :transactions="account.transactions" :address="$route.params.account"></account-transaction-table>
        <!-- voting weight -->
        <br>
        <h4>{{ $t("account.voting_title") }}</h4>
        <i18n path="account.voting_content" tag="p">
          <b place="weight">0</b>
        </i18n>
      </div>
    </div>
  </div>
</template>

<script>
  import qrcode from '@xkeshi/vue-qrcode'
  import AccountTransactionTable from '../components/layout/AccountTransactionTable'
  import LiveTag from '../components/layout/LiveTag'
  import { mapState } from 'vuex'

export default {
    name: 'Account',
    components: {LiveTag, AccountTransactionTable, qrcode},
    mounted () {
      this.$store.dispatch('loadAccount', this.$route.params.account)
    },
    computed: {
      ...mapState(['account']),
      isContract () {
        const a = this.account
        return a && a.contract && a.contract.address
      },
      creator () {
        const a = this.account
        if (a && a.contract) {
          return a.contract.creator
        }
        return ''
      },
      contractCreateAt () {
        const a = this.account
        if (a && a.contract) {
          return a.contract.transaction
        }
        return ''
      },
      completeTransactionCount () {
        const a = this.account
        if (a && a.total_transactions) {
          return a.total_transactions
        } else {
          return 0
        }
      },
      lastUpdate () {
        const a = this.account
        if (a && a.transactions) {
          return this.$utils.formatTimestamp(a.transactions[0].timestamp).toLocaleString()
        } else {
          return 'N/A'
        }
      },
      qrAddress () {
        return window.location.protocol + '//' + window.location.host + '/#/account/' + this.$route.params.account
      }
    }
  }
</script>

<style lang="scss" scoped>
  span.tag {
    margin-top: 1rem;
  }

  table {
    width: 100%;

    td {
      max-width: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    td:first-child {
      width: 26%;
    }

    code {
      word-break: break-all;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Account.vue